import { Component } from "react";
import HelloSign from "hellosign-embedded";
const {REACT_APP_LOCAL_ENVIRONMENT} = process.env;
const debugMode = REACT_APP_LOCAL_ENVIRONMENT === 'true';

class SignDocuments extends Component {
  componentDidMount() {
    const {documents: {clientId, urls}} = this.props;

    HelloSign.init(clientId);


    for (let i = 0; i < urls.length; i++) {
      const url = urls[i];

      HelloSign.open({
        url: url,
        allowCancel: false,
        debug: debugMode,
        skipDomainVerification: debugMode
      });
    }
  }

  render() {
    return null;
  }
}

export default SignDocuments;



// WEBPACK FOOTER //
// ./src/home/containers/sign-documents.js